import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  AddAlert,
  Button,
  IEvent,
  Input,
  IRadioButtonEvent,
  Modal,
  RadioButton,
} from '../../../../component';
import { useTypedSelector } from '../../../../hooks/useTypedSelector';
import { loaded, loading } from '../../../../layout/redux/layoutActions';
import {
  modalOpen,
  setDisplayStudyCreationGuide,
} from '../../redux/dashboardActions';
import { IdNamePair } from '../../types';
import nls from '../nls/pt-BR.json';
import { createStudy } from '../redux/studies.controller';
import { CreateStudyPayload } from '../redux/studies.model';
import { setId, setStudyName } from '../redux/studies.reducer';

export const NewStudyModal: React.FC = () => {
  const OPTIONS: IdNamePair[] = [
    { id: 'shared', name: nls.modal.shared },
    { id: 'private', name: nls.modal.private },
  ];
  const MAX_LENGTH = 30;
  const { statusModal } = useTypedSelector((state) => state.dashboardState);
  const [name, setName] = useState<string>('');
  const [checked, setChecked] = useState<IdNamePair>(OPTIONS[0]);
  const dispatch = useDispatch();
  const handleChangeInput = (e: IEvent) => {
    setName(e.value.slice(0, MAX_LENGTH));
  };
  const handleChangeRadioButton = (e: IRadioButtonEvent) => {
    setChecked({ ...e.value });
  };
  const handleClickCreateStudy = async () => {
    dispatch(setDisplayStudyCreationGuide(false));

    try {
      dispatch(loading());
      const user_name = sessionStorage.getItem('user_name');

      const payload: CreateStudyPayload = {
        name,
        is_public: checked.id === 'shared',
        author: user_name ?? '',
      };

      const { data } = await createStudy(payload);

      if (data) {
        const { id, name } = data.data;
        dispatch([
          setDisplayStudyCreationGuide(true),
          setStudyName(name),
          setId(id),
          AddAlert('success', 'Relatório criado com sucesso'),
        ]);
      }
    } catch (error) {
      console.error(error);
      dispatch(AddAlert('warning', 'Erro ao criar estudo'));
    } finally {
      dispatch([loaded(), modalOpen('')]);
    }
  };
  return (
    <Modal
      open={statusModal === 'new study modal'}
      close={() => dispatch(modalOpen(''))}
      title={nls.modal.newReport}
      cy="NewStudy"
      actions={
        <>
          <Button
            cy="CreateStudy"
            className="btn normal primary"
            onClick={handleClickCreateStudy}
            disabled={name.length === 0}
          >
            {nls.modal.create}
          </Button>
        </>
      }
    >
      <div className="input-container">
        <Input
          label={nls.modal.name}
          placeholder={nls.modal.placeholder}
          cy="NewStudyName"
          value={name}
          action={handleChangeInput}
          style={{
            backgroundColor: '#FFF',
            color: '#000',
            border: '1px solid #383939',
            borderRadius: 4,
          }}
        />
        <span style={{ float: 'right', fontSize: 12 }}>
          {name.length}/{MAX_LENGTH}
        </span>
      </div>
      <div style={{ marginTop: 32 }}>
        <RadioButton
          options={OPTIONS}
          checked={checked}
          action={handleChangeRadioButton}
          label={<span style={{ fontSize: 14 }}>{nls.modal.type}</span>}
          name={nls.modal.type}
          cy="NewStudy"
        />
      </div>
    </Modal>
  );
};
